/* CreepyGoth — Bag drawer "You May Also Like" toggle (DEV only, PDP Final
   Polish 2026-09-23, Task D). Presentation-only; does not touch cart/AJAX
   logic. Uses ONE delegated listener on document, attached once at script
   load - the cart drawer's inner content (including this toggle) gets
   replaced wholesale by the theme's own AJAX cart refresh (see
   CartDrawer.build() in theme.js), so a delegated listener is the only
   approach that keeps working after every refresh without rebinding or
   accumulating duplicate listeners. */
(function () {
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cg-yaml-toggle]');
    if (!trigger) return;

    var wrapper = trigger.closest('[data-cg-yaml]');
    if (!wrapper) return;

    var panel = wrapper.querySelector('[data-cg-yaml-panel]');
    if (!panel) return;

    var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!isExpanded));
    panel.hidden = isExpanded;
  });
})();
